import priceStyle from './ExpressionOfInterestPriceSection.module.css';
import { Row } from 'react-bootstrap';
import { AppConstants } from '../../../constants/AppConstants';
import parse from 'html-react-parser';

const handleScroll = (event, id) => {
    event.preventDefault();
    const element = document.querySelector(id);
    if (element) {
        let offset = 0;

        if (window.innerWidth > 768) {
            offset = (window.innerHeight - element.offsetHeight) / 2;
        }

        const elementPosition =
            element.getBoundingClientRect().top + window.pageYOffset;

        window.scrollTo({
            top: elementPosition - offset,
            behavior: 'smooth',
        });
    }
};

export const ExpressionOfInterestPriceSection = () => {
    const mediaContent = process.env.REACT_APP_MEDIA_CONTENT;
    return (
        <>
            <div id="priceCard" className={priceStyle.pricingCard}>
                <Row>
                    <div
                        className={`${priceStyle.pricingDescription} col-md-4 col-sm-12`}
                    >
                        <div className={priceStyle.section}>
                            <p className={priceStyle.sectionDesc}>{parse(AppConstants.subscriptionPagePriceSectionHeading)}</p>
                        </div>
                        <button
                            className={`${priceStyle.signUpButton} d-none d-md-block`}
                            onClick={(e) => handleScroll(e, '#formSection')}
                        >
                            Subscribe Now
                        </button>
                    </div>

                    <div className="col-md-8 col-sm-12">
                        {/* Desktop Image */}
                        <img
                            className={`${priceStyle.subscriptionImage} d-none d-md-block`}
                            src={`${mediaContent}${AppConstants.subscriptionPriceSectionImage}`}
                            alt="Membership Fee"
                        />

                        {/* Mobile Image */}
                        <img
                            className={`${priceStyle.subscriptionImage} d-block d-md-none`}
                            src={`${mediaContent}${AppConstants.subscriptionPriceSectionImageMobile}`}
                            alt="Membership Fee"
                        />
                    </div>
                    <div className={`${priceStyle.pricingDescription} col-md-4 col-sm-12 d-block d-md-none mt-3`}>
                        <button
                            className={`${priceStyle.signUpButton} `}
                            onClick={(e) => handleScroll(e, '#formSection')}
                        >
                            Subscribe Now
                        </button>
                    </div>

                </Row>
            </div>
        </>
    );
};
